import { cachedProgram } from "./cached-program.js";
import { EdgeRectangleProgram } from "sigma/rendering";
// Two batches share Sigma's stable geometry buffers. Only uniforms change on
// camera frames; focus membership is changed by the existing discrete reducers.
export function atlasEdgeProgram(zoom, focus=false) {
  return class AtlasEdgeProgram extends cachedProgram(EdgeRectangleProgram) {
    render(params) { if (!focus && zoom.style().edgeOpacity === 0) return; super.render(params); }
    getDefinition() {
      const base=super.getDefinition();
      return {...base, UNIFORMS:[...base.UNIFORMS,"u_atlasZoom","u_atlasStart","u_atlasFull","u_atlasFocus"],
        // Base edges need at least one endpoint in the viewport. GPU culling
        // prevents distant links from striping a local neighborhood, without
        // rebuilding topology buffers on pan or zoom. Focus edges are exempt.
        VERTEX_SHADER_SOURCE:base.VERTEX_SHADER_SOURCE.replace("void main() {", `uniform mediump float u_atlasFocus;
void main() {
  vec2 atlasStart = (u_matrix * vec3(a_positionStart, 1.0)).xy;
  vec2 atlasEnd = (u_matrix * vec3(a_positionEnd, 1.0)).xy;
  bool atlasLocal = all(lessThanEqual(abs(atlasStart), vec2(1.02))) || all(lessThanEqual(abs(atlasEnd), vec2(1.02)));
  if (u_atlasFocus < 0.5 && !atlasLocal) { gl_Position = vec4(2.0, 2.0, 0.0, 1.0); return; }
`),
        FRAGMENT_SHADER_SOURCE:base.FRAGMENT_SHADER_SOURCE
          .replace("void main(void)", "uniform float u_atlasZoom;\nuniform float u_atlasStart;\nuniform float u_atlasFull;\nuniform float u_atlasFocus;\nvoid main(void)")
          .replace("gl_FragColor = v_color;", "if (u_atlasFocus < 0.5 && u_atlasZoom <= u_atlasStart) discard; gl_FragColor = v_color;")
          .replace("gl_FragColor = mix(v_color, transparent, t);", "gl_FragColor = mix(v_color, transparent, t) * mix(0.48 * smoothstep(u_atlasStart, u_atlasFull, u_atlasZoom), 0.9, u_atlasFocus);")};
    }
    setUniforms(params,info) {
      super.setUniforms(params,info);
      const s=zoom.style(),{gl,uniformLocations:u}=info;
      gl.uniform1f(u.u_atlasZoom,s.z); gl.uniform1f(u.u_atlasStart,s.edgeStart);
      gl.uniform1f(u.u_atlasFull,s.edgeFull);gl.uniform1f(u.u_atlasFocus,focus?1:0);
    }
  };
}
